import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type {
  GetProductStockRequest,
  GetProductStockResponse
} from '~/types/apis/getProductStock'
import type {
  UpdateWishListRequest,
  UpdateWishListResponse
} from '~/types/apis/updateWishList'

export const productRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getProductStock(
    options: FetchOptions & { body?: GetProductStockRequest } = {}
  ): Promise<GetProductStockResponse> {
    return fetch<GetProductStockResponse>('/v1/storefront/available-stocks', {
      ...options,
      method: 'POST'
    })
  },
  async updateWishList(
    options: FetchOptions & { body?: UpdateWishListRequest } = {}
  ): Promise<UpdateWishListResponse> {
    return fetch<UpdateWishListResponse>('/v1/storefront/product/wishlist', {
      ...options,
      method: 'POST'
    })
  }
})
